import script from "./StreakOffensive.vue?vue&type=script&lang=ts&setup=true"
export * from "./StreakOffensive.vue?vue&type=script&lang=ts&setup=true"

import "./StreakOffensive.vue?vue&type=style&index=0&id=6b7d5a44&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b7d5a44"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
